"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Places;
(function (Places) {
    Places["Top"] = "top";
    Places["Bottom"] = "bottom";
    Places["Left"] = "left";
    Places["Right"] = "right";
})(Places = exports.Places || (exports.Places = {}));
var Modifiers;
(function (Modifiers) {
    Modifiers["Start"] = "start";
    Modifiers["End"] = "end";
})(Modifiers = exports.Modifiers || (exports.Modifiers = {}));
var Placements;
(function (Placements) {
    Placements["TopStart"] = "top-start";
    Placements["Top"] = "top";
    Placements["TopEnd"] = "top-end";
    Placements["LeftStart"] = "left-start";
    Placements["Left"] = "left";
    Placements["LeftEnd"] = "left-end";
    Placements["RightStart"] = "right-start";
    Placements["Right"] = "right";
    Placements["RightEnd"] = "right-end";
    Placements["BottomStart"] = "bottom-start";
    Placements["Bottom"] = "bottom";
    Placements["BottomEnd"] = "bottom-end";
})(Placements = exports.Placements || (exports.Placements = {}));
exports.getPlace = function (placement) { return (placement ? placement.split('-')[0] : Places.Top); };
